import { render, staticRenderFns } from "./RightList.vue?vue&type=template&id=5660769e&scoped=true"
import script from "./RightList.vue?vue&type=script&lang=js"
export * from "./RightList.vue?vue&type=script&lang=js"
import style0 from "./RightList.vue?vue&type=style&index=0&id=5660769e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5660769e",
  null
  
)

export default component.exports